import React from 'react';
import { Button, Modal, ModalBody, Row } from 'reactstrap';

const ConfirmDeleteModal = ({ isOpen, onClose, onConfirm }) => (
  <Modal isOpen={isOpen} toggle={onClose}>
    <ModalBody className="d-flex flex-column align-items-center">
      <h3 className="mx-3 my-2 text-center text-bold">Atenção</h3>
      <h5 className="mx-3 my-2 text-center">
        Tem certeza que deseja excluir este recebedor? Esta ação não poderá ser
        desfeita.
      </h5>
      <Row className="mx-0">
        <Button
          className="d-none d-lg-block new-layout-btn main mt-4 px-5 mr-lg-2"
          color="danger"
          size="lg"
          onClick={onClose}
        >
          Cancelar
        </Button>
        <Button
          className="new-layout-btn main mt-4 mt-lg-4 px-5 ml-lg-2"
          color="success"
          size="lg"
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          Confirmar
        </Button>
        <Button
          className="d-block d-lg-none new-layout-btn main mt-2 px-5 mr-lg-2"
          color="danger"
          size="lg"
          onClick={onClose}
        >
          Cancelar
        </Button>
      </Row>
    </ModalBody>
  </Modal>
);

export default ConfirmDeleteModal;
